import React, { useState } from "react";
import { Row, Col, Button, Select, Collapse, Card, Progress } from "antd";
import { Icon } from "semantic-ui-react";

const { Option } = Select;
const { Panel } = Collapse;

const formatAmount = (value) => {
  if (value == null) return "-";
  const num = parseFloat(value);
  return num < 1000 ? `$${num.toFixed(2)}M` : `$${(num / 1000).toFixed(2)}B`;
};

const StickyClimateFilterHeader = ({
  data,
  analysis,
  rcp,
  ssp,
  year,
  with_content,
  financial,
  adjusted_gdp,
  handleChangePro,
  handleSubmitPro,
  AnalysisOptions,
  RcpOptions,
  YearOptions,
  YearOptions_ssp,
  ContentOptions,
  FinanceOptions,
  GdpOptions,
}) => {
  const {
    asset_table,
    variables = [],
    climate_risk_card_data = {},
    overall = {},
  } = data;

  const scenarioType = analysis === "rcp" ? "RCP" : "SSP";
  const scenarioValue = analysis === "rcp" ? rcp : ssp;
  const riskLabel =
    overall?.overall_risk < 20
      ? "low risk"
      : overall?.overall_risk < 60
      ? "medium risk"
      : "high risk";

  const [activeKey, setActiveKey] = useState([]);

  const getOptions = (options) =>
    options.map((opt) => (
      <Option key={opt.value} value={opt.value}>
        {opt.text || opt.label || opt.value}
      </Option>
    ));

  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 1200,
        background: "#fff",
        padding: "8px 16px 0",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        borderRadius: "0 0 8px 8px",
      }}
    >
      {/* === Header Section === */}

      {/* === Advanced Filter Collapse === */}
      <Collapse
        activeKey={activeKey}
        onChange={(key) => setActiveKey(key)}
        style={{ marginTop: "8px" }}
      >
        <Panel header="Advanced Filters" key="1">
          <Card bordered={false}>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={6} lg={4}>
                <label>Scenario Type</label>
                <Select
                  value={analysis}
                  onChange={(value) => handleChangePro(value, "analysis")}
                  placeholder="Scenario Type"
                  style={{ width: "100%" }}
                >
                  {getOptions(AnalysisOptions)}
                </Select>
              </Col>

              <Col xs={24} sm={12} md={6} lg={4}>
                <label>Scenario</label>
                <Select
                  value={analysis === "rcp" ? rcp : ssp}
                  onChange={(value) =>
                    handleChangePro(value, analysis === "rcp" ? "rcp" : "ssp")
                  }
                  placeholder="Scenario"
                  style={{ width: "100%" }}
                >
                  {getOptions(RcpOptions)}
                </Select>
              </Col>

              <Col xs={24} sm={12} md={6} lg={4}>
                <label>Year</label>
                <Select
                  value={year}
                  onChange={(value) => handleChangePro(value, "year")}
                  placeholder="Year"
                  style={{ width: "100%" }}
                >
                  {getOptions(
                    analysis === "rcp" ? YearOptions : YearOptions_ssp
                  )}
                </Select>
              </Col>

              <Col xs={24} sm={12} md={6} lg={4}>
                <label>Content Type</label>
                <Select
                  value={with_content}
                  onChange={(value) => handleChangePro(value, "with_content")}
                  placeholder="Content Type"
                  style={{ width: "100%" }}
                >
                  {getOptions(ContentOptions)}
                </Select>
              </Col>

              <Col xs={24} sm={12} md={6} lg={4}>
                <label>Analysis</label>
                <Select
                  value={financial}
                  onChange={(value) => handleChangePro(value, "financial")}
                  placeholder="Analysis"
                  style={{ width: "100%" }}
                >
                  {getOptions(FinanceOptions)}
                </Select>
              </Col>

              <Col xs={24} sm={12} md={6} lg={4}>
                <label>Additional Factor</label>
                <Select
                  value={adjusted_gdp}
                  onChange={(value) => handleChangePro(value, "adjusted_gdp")}
                  placeholder="Additional Factor"
                  style={{ width: "100%" }}
                >
                  {getOptions(GdpOptions)}
                </Select>
              </Col>

              <Col span={24} style={{ textAlign: "right" }}>
                <Button
                  type="primary"
                  onClick={handleSubmitPro}
                  style={{
                    backgroundColor: "#18202F",
                    borderColor: "#18202F",
                  }}
                >
                  Apply Filters
                </Button>
              </Col>
            </Row>
          </Card>
        </Panel>
      </Collapse>
      <Row
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Col lg={16} style={{ fontSize: "0.9rem" }}>
          <p
            style={{
              marginBottom: "0px",
              fontSize: "1.2rem",
              fontWeight: 500,
            }}
          >
            Physical Climate Risk Assessment &nbsp;|&nbsp;
            <span
              style={{
                marginBottom: "0px",
                fontSize: "1.2rem",
                fontWeight: 200,
              }}
            >
              {asset_table?.length || 0} Assets · {variables.length} Hazards ·{" "}
              {scenarioType} {scenarioValue} · Year {year}
            </span>
          </p>
        </Col>
        <Col
          lg={8}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: "12px",
          }}
        >
          <span style={{ fontSize: "1.2rem", fontWeight: 500 }}>
            Climate Score:
          </span>
          <span style={{ fontSize: "1.2rem", fontWeight: 200 }}>
            {overall?.overall_risk?.toFixed(0)}%
          </span>
          <span
            style={{
              padding: "2px 8px",
              borderRadius: "12px",
              background:
                riskLabel === "low risk"
                  ? "#4CAF50"
                  : riskLabel === "medium risk"
                  ? "#FFC107"
                  : "#F44336",
              color: "#fff",
              fontSize: "1.2rem",
              textTransform: "capitalize",
            }}
          >
            {riskLabel}
          </span>
        </Col>
      </Row>
      <Progress
        percent={overall?.overall_risk?.toFixed(0)}
        size="small"
        showInfo={false}
        style={{ marginBottom: "0.5%", padding: "0.5%" }}
      />
    </div>
  );
};

export default StickyClimateFilterHeader;
